const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArticlesEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.99005 8.57005L7.99005 6.57005L3.84005 2.43005L2.43005 3.84005L5.16005 6.57005H4.43005C3.88005 6.57005 3.43005 7.02005 3.43005 7.57005V17.5701C3.43005 18.1201 3.88005 18.5701 4.43005 18.5701H16.4301C16.6401 18.5701 16.8201 18.4901 16.9801 18.3901L20.1601 21.5701L21.5701 20.1601L12.7101 11.3001L9.99005 8.57005ZM5.43005 16.5701V8.57005H7.16005L15.1601 16.5701H5.43005ZM15.4301 8.57005V11.1801L21.4301 17.1801V7.07005L17.4301 11.0701V7.57005C17.4301 7.02005 16.9801 6.57005 16.4301 6.57005H10.8201L12.8201 8.57005H15.4301Z",
    fill: props.fill
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArticlesEmptyState);
export default __webpack_public_path__ + "static/media/ic_articles_empty_state.aaa3592f197b9400eb9c196b52b22dda.svg";
export { ForwardRef as ReactComponent };